const Constants = {

    //Different modes to handle data in NewReport.js
    MODE_NEW_REPORT: 'MODE_NEW_REPORT',
    MODE_VIEW_REPORT: 'MODE_VIEW_REPORT',

}

export default Constants;